module.exports = __webpack_public_path__ + "img/25.fd159314.jpg";